export default __webpack_public_path__ + "static/media/(71).dec93ddc.jpg";